import {
  IconButton,
  withStyles
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { withSnackbar } from "notistack";

const styles = theme => ({
  closeIcon: {
    color: theme.snackBarCloseIcon,
  }
});

const DismissSnackbar = props => {
  const { classes } = props;
  return (
    <IconButton
      aria-label="cancel"
      onClick={() => {
        props.closeSnackbar(props.snackBarId);
      }}
      className={classes.closeIcon}
    >
      <CancelIcon />
    </IconButton>
  );
};

export default withStyles(styles)(withSnackbar(DismissSnackbar));
